<ui-bottom-sheet-shell
    [title]="'customers.ui.notifiche' | transloco"
    (close)="onClose()"
>
    <div bottom-sheet-content class="notifications-list">
        @for (item of data.notifications; track item.Id) {
            <div class="notification-card" [class]="getNotificationCardClass(item.Severity)">
                <div class="notification-card-header">
                    <div class="notification-card-header-container">
                        <div class="notification-card-header-icon-container">
                            <div class="notification-card-icon">
                                <i [class]="getNotificationIconClass(item.Severity) + ' ' + getNotificationIconColorClass(item.Severity)"></i>
                            </div>
                        </div>

                        <div class="notification-card-header-content">
                            <span class="body-medium-emphasized notification-card-title" [class]="getNotificationIconColorClass(item.Severity)">{{ item.Title }}</span>
                            <span class="body-medium notification-card-description">{{ item.Description || '-' }}</span>
                            @if (item.RequiresNoteFlg) {
                                <span class="body-medium notification-card-description">{{ 'customers.ui.ordineInseribileConNotaObbligatoria' | transloco }}</span>
                            }
                        </div>
                    </div>

                    <div class="notification-card-header-close">
                        <button matIconButton type="button" (click)="$event.stopPropagation()">
                            <i class="fa-regular fa-xmark"></i>
                        </button>
                    </div>
                </div>

                <div class="notification-card-footer">
                    @if (item.ToAction) {
                        <button matButton type="button" class="notification-card-action">
                            <span class="notification-card-action-content">
                                <i class="fa-regular fa-up-right-from-square"></i>
                                <span>{{ getNotificationActionLabel(item) }}</span>
                            </span>
                        </button>
                    }
                </div>
            </div>
        }
    </div>
</ui-bottom-sheet-shell>
